import React, { useEffect, useRef, useState } from "react";
import "./AboutSection.css";
import { useAnimation, motion } from "framer-motion";
import StyledH2Heading from "../../../common/components/styledH2Heading/StyledH2Heading";
import StyledH5Heading from "../../../common/components/styledH5Heading/StyledH5Heading";

const styles = {
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundImage: "url('/assets/about-bg.png')",
};

const AboutSection = () => {
  const controls = useAnimation();
  const ref = useRef(null);
  const [animatedOnce, setAnimatedOnce] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            controls.start({ opacity: 1, y: 0 });
            setAnimatedOnce(true);
          } else {
            if (animatedOnce) {
              controls.start({ opacity: 0, y: 100 });
              setAnimatedOnce(false);
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [controls, animatedOnce]);

  return (
    <div id="about" style={styles} className="flex justify-center w-full">
      <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-10 w-11/12 sm:w-[85%] py-10 2xl:h-screen">
        {/* Friends Frogs Image */}
        <div>
          <img
            src="/assets/about-jaba-spaceship.png"
            alt="Jaba The Pepe"
            className="spaceship"
          />
          <img src="/assets/about-jaba-frogs.png" alt="Jaba The Pepe" />
        </div>

        {/* About Us */}
        <div className="flex flex-col justify-center items-center text-center gap-5 gradientBackground h-full 2xl:h-[80%] rounded-2xl p-4 sm:p-8 lg:w-[70%] xl:w-[48%] overflow-hidden">
          {/* Heading */}
          <div>
            <StyledH2Heading font="text-white">
              About <br /> Jaba the pepe
            </StyledH2Heading>
          </div>

          {/* Description */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 100 }}
            animate={controls}
            transition={{ duration: 0.5 }}
            className="space-y-8"
          >
            <StyledH5Heading font="text-white">
              In publishing and graphic design, Lorem ipsum is a placeholder
              text commonly used to demonstrate the visual form of a document or
              a typeface without relying on meaningful content. Lorem ipsum may
              be used as a placeholder before the final copy is available
            </StyledH5Heading>
            <StyledH5Heading font="text-white">
              In publishing and graphic design, Lorem ipsum is a placeholder
              text commonly used to demonstrate the visual form of a document or
              a typeface without relying on meaningful content. Lorem ipsum may
              be used as a placeholder before the final copy is available
            </StyledH5Heading>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
